// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7fa3cce2","453":"3b01896e","455":"692e48e1","977":"dc8287db"}[chunkId] + ".chunk.js";
};